import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { reqGET } from '../../../Utils';
import { api_list_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id_serch) => {

        let list_route = api_list_route(getTokenInfo().companycode)
        //console.log(list_route)
        //return await reqGET(`${api_crud_route}/${id_serch}`)
        return await reqGET(`${list_route}/${id_serch}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {



        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">LOADING</h2>
                    <p>LOADING</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">Suporte</h2>
                    <p>Home / Suporte / {dados.info.name}</p>
                </div>

                <div className={`dash-cards-2 body`}>
                    <div className="card">
                        <div className="card-body">
                            <h2 className="dash-title">{dados.info.name}</h2>
                            <div className="div-break" />
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>Pergunta</h4>
                                    <p>{dados.content.question}</p>
                                </span>
                                <span className="flex-1">
                                    <h4>Resposta</h4>
                                    <p>{dados.content.answer}</p>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <img alt='' src={'./img/seta_2.svg'} />
                                        <span>Voltar</span>
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </nav>
                </div>
            </main >
}